import {SirenHelper} from "./siren.helper";
import {HalHelper} from "./hal.helper";
import {JsonhelperInterface} from "./jsonhelper.interface";
import {DetailConfigurationField} from "../models/detail-configuration-field";
import {HelperService} from '../services/helperService';


/**
 * Class > ContentsHelper
 *
 * Klasse die weiss wie sie Daten aus dem Listing-json auslesen soll
 */
export class ContentsHelper {
	/**
	 * Attribute
	 */
	private OBJ_json_helper: JsonhelperInterface;

	private OBJ_helper_service: HelperService = new HelperService();


	/**
	 * Function > constructor
	 * @param OBJ_data
	 * @param STR_type
	 * @param STR_url
	 */
	constructor(private OBJ_data, private STR_type = "", private STR_url = "") {
		// Ist der Inhalt im HAL oder Siren-Format uebergeben?
		switch (STR_type) {
			case "application/vnd.siren+json":
				this.OBJ_json_helper = new SirenHelper();
				break;
			default:
				this.OBJ_json_helper = new HalHelper();
				break;

		} // end switch

	} // end function constructor


	/**
	 * Function > getListingData
	 *
	 * @desc Gibt die Daten fuer Tabelle zurueck
	 * @return Array<any>
	 */
	getListingData(): Array<any> {
		return this.OBJ_json_helper.getEmbeddedRessources(this.OBJ_data);
	} // end function getListingData


	/**
	 * Function > getDetailValuesEndpoint
	 *
	 * @desc Liest den REST-Endpoint zur Detailansicht aus dem uebergebenen Datensatz aus
	 * @param OBJ_entry
	 * @param {string} STR_rel
	 * @return {any}
	 */
	getDetailValuesEndpoint(OBJ_entry, STR_rel = "self"): string {
		return this.OBJ_json_helper.getLinkByRel(STR_rel, OBJ_entry);
	} // end function getDetailValuesEndpoint


	/**
	 * Function > getValues
	 *
	 * @desc Gibt den Wert zum angefragten Feld zuruech falls vorhanden, ansonsten undefined
	 * @param OBJ_entry
	 * @param {string} STR_key
	 * @return {any}
	 */
	getValue(STR_key: string, OBJ_entry = this.OBJ_data) {
		return this.OBJ_json_helper.getProperty(STR_key, OBJ_entry);
	} // end function getValue


	/**
	 * Function > getLinkToSelf
	 * @return {string}
	 */
	getLinkToSelf(OBJ_json = this.OBJ_data) {
		return this.OBJ_json_helper.getLinkToSelf(OBJ_json);
	} // end function getLinkToSelf

	/**
	 * Function > getLinkToSelf
	 * @return {string}
	 */
	getLinkToIFrame(OBJ_json = this.OBJ_data) {
		return this.OBJ_json_helper.getLinkByRel("iframe", OBJ_json);
	} // end function getLinkToSelf


	/**
	 * Function > getTotalNumberOfItems
	 *
	 */
	getTotalNumberOfItems(OBJ_json = this.OBJ_data) {
		return this.OBJ_json_helper.getProperty("total_items", OBJ_json);
	} // end function getTotalNumberOfItems


	/**
	 * Getter > data
	 *
	 * @desc Gibt die kompletten Daten aus dem Backend weiter
	 * @return {{[p: string]: any}}
	 */
	get data() {
		return this.OBJ_data;
	} // end getter data

	updateField(STR_property_name, MIX_value) {
		this.OBJ_json_helper.updateProperty(STR_property_name, MIX_value, this.OBJ_data);
	}


	/**
	 * Function > findId
	 *
	 * @desc Find id-value - fetch it from link to self
	 * @param OBJ_data
	 */
	findId(OBJ_data) {
		let STR_url = this.getLinkToSelf(OBJ_data);

		let ARR_parts = STR_url.split('/');

		return ARR_parts.pop();

	} // end function findId


	/**
	 * Function > updateData
	 * @param OBJ_form_fields: FieldConfig[]
	 * @param ARR_save_seperately
	 * @param OBJ_data
	 * @return Gibt aktualisierte Daten zurueck
	 */
	updateData(OBJ_form_fields: DetailConfigurationField[], ARR_save_seperately = [], OBJ_data = this.OBJ_data) {
		OBJ_form_fields.forEach(OBJ_field => {
			// Gehe Daten durch und aktualisiere Felder

			let ARR_objects = [];
			switch (OBJ_field.type) {

				case "array":
				case "publicationobjects":
					// Nicht alle types werden im array unterstuetzt
					// Weitere Felder muestten je nach Situation implementiert werden.
					let ARR_publication_objects = [];

					let itemdatetypefields = {};
					if (OBJ_field.fields) {
						// Gehe einzelne Felder des arrays durch und setze sie
						for (let OBJ_entry of OBJ_field.fields) {

							// Handelt es sich nicht um ein Feld, das eine abzuspeichernde Struktur hat, mache weiter
							if(OBJ_entry.object_structure === undefined)
							{
								continue;
							}

							// multiselect
							switch (OBJ_entry.type) {
								case "select_multiple":
									if (OBJ_entry.value && OBJ_entry.value.length > 0) {
										if (OBJ_entry.multiple === true) {
											let ARR_ids = [];
											for (let OBJ_value of OBJ_entry.value) {
												ARR_ids.push(OBJ_value.id);
											} // end for

											OBJ_entry.object_structure.ids = ARR_ids;
										}
										// keine multiple selection
										else if (OBJ_entry.value[0].id) {
											OBJ_entry.object_structure.id = OBJ_entry.value[0].id;
										} // end if
									} else {
										// Keine Auswahl getroffen, id ist null
										OBJ_entry.object_structure.id = null;
										OBJ_entry.object_structure.ids = [];
									}
									break;
								case "input":
								case "select":
									OBJ_entry.object_structure.id = OBJ_entry.value;
									break;
								case "date":
									// daterange?
									if (OBJ_entry.selectMode == "range") {
										OBJ_entry.object_structure.datefrom = OBJ_entry.value[0];
										OBJ_entry.object_structure.dateto = OBJ_entry.value[1]
									} else {
										OBJ_entry.object_structure.datefrom = OBJ_entry.value[0];
									}
									break;
								default:
									// Keine Auswahl getroffen, id ist null
									OBJ_entry.object_structure.id = null;
									OBJ_entry.object_structure.ids = [];
									break;

							}

							// die drei Daten dieses Types gehoeren zusammen
							if(OBJ_entry.object_structure.type === "itemdateselect")
							{

								itemdatetypefields[OBJ_entry.type] = OBJ_entry;
								// Sind alle drei types gesetzt?
								if(
									itemdatetypefields.hasOwnProperty("input") &&
									itemdatetypefields.hasOwnProperty("date") &&
									itemdatetypefields.hasOwnProperty("select")
								)
								{
									// Fuehre Eintraege zusammen
									// Datum als Grundfeld nehmem
									let merged_entry = itemdatetypefields["date"].object_structure;
									// ID stammt aus Input-Feld
									merged_entry["id"] = itemdatetypefields["input"].object_structure.id;
									// Type wird aus select-Feld befuellt
									merged_entry["entity"] = itemdatetypefields["select"].object_structure.id;
									// Speichere zusammengefuhrtes Publikationsobjekt ab
									ARR_publication_objects.push(merged_entry);
									// Setzte Objekt wieder zurueck
									itemdatetypefields = {};
								}
							}
							else
							{
								ARR_publication_objects.push(OBJ_entry.object_structure);
							}

						} // end for

					} // end if

					this.OBJ_json_helper.updateProperty(OBJ_field.name, ARR_publication_objects, OBJ_data);
					break;

				// Assignments
				case "array_static":
					let ARR_assignments = this.OBJ_json_helper.getProperty(OBJ_field.name, OBJ_data);

					// Aktuell werden im Array nicht alle Elemente unterstuetzt
					if (OBJ_field.fields) {
						// Gehe einzelne Felder des arrays durch und befuelle sie korrekt
						for (let OBJ_entry of OBJ_field.fields) {
							let ARR_ids = [];

							switch (OBJ_entry.type) {
								case "select_multiple":
									if (OBJ_entry.value && OBJ_entry.value.length > 0) {
										for (let OBJ_item of OBJ_entry.value) {
											ARR_ids.push(OBJ_item.id);
										} // end for

										// Fuege IDs in vorgegebene Struktur ein
										OBJ_entry.object_structure.ids = ARR_ids;

										// Fuege assignment nur hinzu, wenn Inhalt ausgewaehlt wurde
										if (ARR_ids.length > 0) {
											ARR_objects.push(OBJ_entry.object_structure);
										} // end if
									} else {
										// reset entry
										OBJ_entry.object_structure.ids = [];
										ARR_objects.push(OBJ_entry.object_structure);
									}// end if
									break;

								case "select_multiple_check":
									if (OBJ_entry.value && OBJ_entry.value.length > 0) {
										// id steht direkt in array mit Namen value
										OBJ_entry.object_structure.ids = OBJ_entry.value;
										ARR_objects.push(OBJ_entry.object_structure);

									} else {
										// reset entry
										OBJ_entry.object_structure.ids = [];
										ARR_objects.push(OBJ_entry.object_structure);
									} // end if
									break;

								case "file_upload":
									if (OBJ_entry.value) {
										// Ein neues Bild wurde hochgeladen
										if (OBJ_entry.value instanceof Blob) {
											// Vermerke Daten, um es getrennt an API schicken zu koennen
											ARR_save_seperately.push(OBJ_entry);
										}
										// Kein neues Bildhochgeladen, altes beibehalten
										else {
											// Behalte altes Bild bei, dessen ID in enhanceField unter object_structure gespeichert wurde
											ARR_objects.push(OBJ_entry.object_structure);
										}
									} else {
										let sOBJ_entry = JSON.parse(JSON.stringify(OBJ_entry));
										sOBJ_entry.object_structure.delete = true;
										// reset entry
										OBJ_entry.object_structure.ids = [];
										ARR_objects.push(OBJ_entry.object_structure);
									} // end if
									break;

							} // end switch

						} // end for

					} // end if

					for (let OBJ_edited_assignment of ARR_objects) {
						if (ARR_assignments && ARR_assignments.length > 0) {
							let INT_index_existing_assignment = ARR_assignments.findIndex(OBJ_assignment => OBJ_assignment.title === OBJ_edited_assignment.title);

							if (INT_index_existing_assignment !== -1) {
								// overwrite existing assignment
								ARR_assignments[INT_index_existing_assignment] = OBJ_edited_assignment;
							} else {
								// add new assignment
								ARR_assignments.push(OBJ_edited_assignment);
							} // end if

						} else {
							// create array assignments & add new entry
							ARR_assignments = [];
							ARR_assignments.push(OBJ_edited_assignment);
						} // end if

					} // end for

					// Fuelle den Array mit den befuellten Objekten
					this.OBJ_json_helper.updateProperty(OBJ_field.name, ARR_assignments, OBJ_data);
					break;

				case "object":

					// Interne Infos nicht updaten
					if (OBJ_field.name != "systeminfo") {
						if (OBJ_field.flat_object) {
							// Daten wurden nur auf Oberflaeche zusammengefasst, in Json selbst sind sie flach
							this.updateData(OBJ_field.fields, ARR_save_seperately, OBJ_data);
						} else {
							this.updateData(OBJ_field.fields, ARR_save_seperately, this.OBJ_json_helper.getProperty(OBJ_field.name, OBJ_data));
						} // end if

					} // end if

					break;

				case "assignments":

					if (OBJ_field.fields) {

						// go through individual field of the array and fill them correctly
						for (let OBJ_entry of OBJ_field.fields) {

							let ARR_ids = [];
							// insert id of selected values into assignment
							if (OBJ_entry.value && OBJ_entry.type == "select_multiple") {

								for (let OBJ_item of OBJ_entry.value) {
									ARR_ids.push(OBJ_item.id);
								} // end for

								// insert ids into given structure
								OBJ_entry.object_structure.ids = ARR_ids;

								// add assignment only if content has been selected
								if (ARR_ids.length > 0) {
									ARR_objects.push(OBJ_entry.object_structure);
								} // end if

							} else if (OBJ_entry.value && OBJ_entry.type == "select") {

								// id stands directly in array with name value
								OBJ_entry.object_structure.ids = Array.isArray(OBJ_entry.value) ? OBJ_entry.value : [OBJ_entry.value];
								ARR_objects.push(OBJ_entry.object_structure);

							} else if (OBJ_entry.value && OBJ_entry.type == "select_multiple_check") {

								// id stands directly in array with name value
								OBJ_entry.object_structure.ids = OBJ_entry.value;
								ARR_objects.push(OBJ_entry.object_structure);

							} else if (OBJ_entry.type == "object" && OBJ_entry.fields) {

								for (let OBJ_field of OBJ_entry.fields) {

									if (typeof OBJ_field.value !== 'undefined' && OBJ_field.type == "select") {
										OBJ_entry.object_structure.ids = Array.isArray(OBJ_field.value) ? OBJ_field.value : [OBJ_field.value];
									}

									if (typeof OBJ_field.value !== 'undefined' && OBJ_field.type == "input") {
										OBJ_entry.object_structure.value = OBJ_field.value;
									} // end if

								} // end for

								ARR_objects.push(OBJ_entry.object_structure);

							}
							// if it is file/image upload, collect data to be able to upload file separately
							else if (!OBJ_entry.file_object && OBJ_entry.type == "file_upload") {

								// a new picture was uploaded
								if (
									OBJ_entry.value != null &&
									OBJ_entry.value instanceof Blob
								) {
									// notes data to be able to send it separately to API
									ARR_save_seperately.push(OBJ_entry);
								}
								// no new picture uploaded
								else if (OBJ_entry.value != null) {
									// retain old image whose id was saved in enhanceField under object_structure
									ARR_objects.push(OBJ_entry.object_structure);
								} else {
									// no picture uploaded or picture was deleted - if it is to be deleted from the backend as well, this would be the opportunity to do something about it
								} // end if

							} // end if

						} // end for

					} // end if

					// fill the array with the filled objects
					this.OBJ_json_helper.updateProperty(OBJ_field.name, ARR_objects, OBJ_data);
					break;

				case "select":
					// Wenn Wert eine Nummer ist, dann in int casten
					if (isNaN(OBJ_field.value)) {
						this.OBJ_json_helper.updateProperty(OBJ_field.name, OBJ_field.value, OBJ_data);
					} else {
						this.OBJ_json_helper.updateProperty(OBJ_field.name, parseInt(OBJ_field.value, 10), OBJ_data);
					} // end if

					break;

				case "select_multiple":
					if (OBJ_field.id_only && OBJ_field.value !== null) {
						let ARR_ids = [];
						for (let $OBJ_value of OBJ_field.value) {
							ARR_ids.push($OBJ_value.id);
						} // end for

						// speichere nur das ID-Feld
						this.OBJ_json_helper.updateProperty(OBJ_field.name, ARR_ids, OBJ_data);
					} else {
						this.OBJ_json_helper.updateProperty(OBJ_field.name, OBJ_field.value, OBJ_data);
					} // end if

					break;

				case "dual_list":
					let ARR_children = [];
					for (let counter = 0; counter < OBJ_field.value.length; counter++) {
						const OBJ_child = OBJ_field.value[counter];
						ARR_children.push({"id": OBJ_child.id, "order": OBJ_child.order ? OBJ_child.order : (counter + 1)});
					} // end for

					this.OBJ_json_helper.updateProperty(OBJ_field.name, ARR_children, OBJ_data);
					break;

				case "file_upload" :

					if (!OBJ_field.file_object) {
						ARR_save_seperately.push(OBJ_field);
					}

					break;

				case "textarea_json":
					this.OBJ_json_helper.updateProperty(OBJ_field.name, JSON.parse(OBJ_field.value), OBJ_data);
					break;

				default:
					this.OBJ_json_helper.updateProperty(OBJ_field.name, OBJ_field.value, OBJ_data);
					break;


			} // end switch

		})

		// console log
		this.OBJ_helper_service.log
		(
			{class: ContentsHelper.name, function: 'updateData'},
			"This is the updated data",
			this.OBJ_json_helper.getProperties(OBJ_data)
		);

		return this.OBJ_json_helper.getProperties(OBJ_data);

	} // end function updateData


	get url() {
		return this.STR_url;
	}


} // end class ContentsHelper
